import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import {  useNavigate, useParams } from "react-router-dom"
import { useGetGroupsQuery } from '../groups/groupsApiSlice'
import { useState } from "react"
import TasksList from './TasksList'
import useAuth from "../../hooks/useAuth"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import { Button } from "@mui/material"
import TaskEditMulti from "./TaskEditMulti"
function TasksListFilter() {
    const {groupId} = useParams()
    const {isAdmin, isTeacher, isStudent} = useAuth()
    useTitle('geshtop-Exercise: Tasks List')
    const [active,setActive] = useState(false)
    const [status,setStatus] = useState(0)
    const [selected, setSelected] = useState([])
    const [showModal,setShowModal] = useState(false)

    const [q,setQ] = useState('')

    const navigate = useNavigate()
    const handleEditMulti = ()=>{
        if(selected.length){
            setShowModal(true)
        }
    }
    
    let editMulti = ""
    if(isAdmin|| isTeacher){editMulti=(<>
        <Button style={{marginRight:"10px", opacity: selected.length ===0? "0.4 ": "1"}}  color={selected.length ===0? "info": "primary"} variant="contained" onClick={handleEditMulti} >עדכון מרובה  {selected.length} נבחרים</Button>

    </>
    )}

   
    const content =(<>
    <div className="filter-form">
        <h2> משימות </h2>
        <div className="filter-form-item">
        <label className="form__label form__checkbox-container" htmlFor="active">
                    משימות בתוקף:
                    <input
                        className="form__checkbox"
                        id="active"
                        name="active"
                        type="checkbox"
                        checked={active}
                        onChange={(e)=>setActive(prev => !prev)}
                    />
                    </label>
                    </div>
                    <div className="filter-form-item">

                    
                <select
                    id="status"
                    name="status"
                    className={`form__select `}
                    value={status}
                    onChange={(e)=>setStatus(e.target.value)}
                >
                    <option value={0}>--סטטוס--</option>
                    <option value={1}>בוצע</option>
                    <option value={2}>לא בוצע</option>
                    <option value={3}> עם ציון </option>
                    <option value={4}> ללא ציון </option>
                </select>

        </div>
        <div className="filter-form-item">
            <input className="form__input" onChange={(e)=>setQ(e.target.value)} />
            </div>
            {editMulti}
    </div>
 <TasksList  selected={selected} setSelected={setSelected} group={groupId} q={q} active={active} status={status} />
    {showModal && <TaskEditMulti setSelected={setSelected} setShowModal={setShowModal} selected={selected} /> }

</> ) 
  return content;
}

export default TasksListFilter